import { createFileRoute } from '@tanstack/react-router'
import { trpc } from '@/main'
import { noop, useSuspenseQuery } from '@tanstack/react-query'
import { GroupLogin } from '@/routes/_app/-components/orgs/group-login'
import { GroupLoginPending } from '@/routes/_app/-components/orgs/group-login-pending'

export const Route = createFileRoute('/_public/orgs/$orgId/users/groups/$groupId/')({
  context: ({ params }) => ({ orgAndGroupsQueryOptions: trpc.orgs.getOrgAndGroups.queryOptions(params.orgId) }),
  loader: ({ context }) => {
    context.queryClient.query(context.orgAndGroupsQueryOptions).catch(noop)
  },
  component: RouteComponent,
  pendingComponent: GroupLoginPending,
})

function RouteComponent() {
  const context = Route.useRouteContext()
  const { data: org } = useSuspenseQuery(context.orgAndGroupsQueryOptions)
  const { orgId, groupId } = Route.useParams()
  return <GroupLogin orgId={orgId} groupId={groupId} org={org} />
}
